import React, { useMemo } from 'react';
import take from 'lodash/take';
import { Tooltip } from '@vectord/components';

const MAX_MENTEES_WHEN_TRIMMED = 3;

function SuperBatchMenteeEmails({ menteeEmails, trimIfMany = false }) {
  const shouldTrim =
    trimIfMany && menteeEmails.length > MAX_MENTEES_WHEN_TRIMMED;

  const allMenteeEmails = useMemo(() => {
    return menteeEmails.join(', ');
  }, [menteeEmails]);

  const visibleMenteeEmails = useMemo(() => {
    if (shouldTrim) {
      const trimmedEmails = take(menteeEmails, MAX_MENTEES_WHEN_TRIMMED);

      const emails = trimmedEmails.join(', ');
      const remainingMenteesCount =
        menteeEmails.length - MAX_MENTEES_WHEN_TRIMMED;

      return `${emails} and ${remainingMenteesCount} more`;
    } else {
      return allMenteeEmails;
    }
  }, [allMenteeEmails, menteeEmails, shouldTrim]);

  return (
    <Tooltip
      title={allMenteeEmails}
      isDisabled={!shouldTrim}
      className="dark"
    >
      {visibleMenteeEmails}
    </Tooltip>
  );
}

export default SuperBatchMenteeEmails;
